<div>
  @if (showEditPersonModal) {
<app-people-add-modal
   
    [personToEdit]="person"
    (personFormSubmitted)="editPerson($event)">
  </app-people-add-modal>
}

  @if (showTeamAssignationModal) {
<app-team-assignation-modal
   
    [people]="person"
    (modalClosed)="editTeamAssignation($event)">   
  </app-team-assignation-modal>
}

</div>

<div class="container-fluid py-4">
  <div class="row mb-4 align-items-center">
    <div class="col-12">
      <h2 class="text-capitalize d-flex align-items-center fw-bold mb-0">
        <app-avatar [personOrPeople]="person" size="xlarge" shape="circle" class="me-3"></app-avatar>
        {{ person.firstName }} {{ person.lastName }}
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary rounded-circle border-0 ms-3 d-flex align-items-center justify-content-center"
          title="{{ 'COMMON.EDIT' | translate }}"
          (click)="openEditPersonModal(person)">
          <i class="bi bi-pencil-fill text-secondary"></i>
        </button>
      </h2>
    </div>
  </div>

  <div class="row mb-4">
  <div class="col-12">
    <div class="card shadow-sm border-0">
      <div class="card-header bg-white border-bottom-0 pt-4">
        <h3 class="h5 fw-bold mb-0">Details</h3>
      </div>
      <div class="card-body">
        <div class="row align-items-start"> 
          <div class="col-md-4">
            <div class="d-flex align-items-center mb-2">
              <i class="bi bi-person-badge-fill text-muted me-2"></i>
              <span class="text-dark me-1">{{ 'PEOPLE.ROLE' | translate }}:</span>
              <strong class="flex-grow-1">
                <a [routerLink]="['/roles', person.role?.id]" class="text-dark text-decoration-none">
                  {{ person.role?.name }}
                </a>
              </strong>
            </div>
            <div class="d-flex align-items-center mb-2">
              <i class="bi bi-calendar-plus text-muted me-2"></i>
              <span class="text-dark me-1">{{ 'PEOPLE.HIRING_DATE' | translate }}:</span>
              <strong class="flex-grow-1" [attr.title]="person.hiring_date | date: 'dd MMMyyyy'">
                {{ person.hiring_date | date: 'dd MMM yyyy' }}
              </strong>
            </div>
          </div>

          <div class="col-md-4">
            <div class="d-flex align-items-center mb-2">
              <i class="bi bi-briefcase-fill text-muted me-2"></i>
              <span class="text-dark me-1">{{ 'PEOPLE.STATUS' | translate }}:</span>
              <app-people-status [person]="person"></app-people-status>
            </div>
            <div class="d-flex align-items-center mb-2">
              <i class="bi bi-calendar-x text-muted me-2"></i>
              <span class="text-dark me-1">{{ 'PEOPLE.EXIT_DATE' | translate }}:</span>
              <strong class="flex-grow-1" [attr.title]="person.exit_date ? (person.exit_date | date: 'dd MMMyyyy') : null">
                {{ person.exit_date ? (person.exit_date | date: 'dd MMM yyyy') : 'N/A' }}
              </strong>
            </div>
          </div>

          <div class="col">
            <div class="alert allocation-rate-box d-flex flex-column justify-content-center align-items-center h-100 p-2 mb-0 border rounded"
                [ngClass]="getAllocationRateClass()">
                <div class="fw-bold fs-4">{{ person.total_allocation_rate }}%</div>
                <div class="small text-center">{{ 'PEOPLE.DETAILS.TOTAL_ALLOCATION_RATE' | translate }}</div>
            </div>
          </div>
        </div>

        <div class="row border-top mt-3"> 
          <ul class="list-unstyled mb-0">
              <li class="pt-1 d-flex flex-wrap align-items-center small text-muted">
                <span class="me-4 mb-1 mb-md-0">
                  <i class="bi bi-clock-history me-1"></i>
                  <span class="me-1">{{ 'COMMON.CREATED_AT' | translate }}:</span>
                  <strong [attr.title]="person.createdAt | date: 'dd MMM yyyy HH:mm'">
                    {{ person.createdAt | date: 'dd MMM yyyy' }}
                  </strong>
                </span>
                <span class="mb-1 mb-md-0">
                  <i class="bi bi-arrow-clockwise me-1"></i>
                  <span class="me-1">{{ 'COMMON.UPDATED_AT' | translate }}:</span>
                  <strong [attr.title]="person.updatedAt | date: 'dd MMM yyyy HH:mm'">
                    {{ person.updatedAt | date: 'dd MMM yyyy' }}
                  </strong>
                </span>
              </li>
            </ul>
        </div>

      </div>
    </div>
  </div>
</div>

  <div class="row mb-4">
    <div class="col-lg-6 mb-4">
      <div class="card shadow-sm border-0">
        <div class="card-header d-flex justify-content-between align-items-center bg-white border-bottom-0 pt-4">
          <h3 class="h5 fw-bold mb-0">{{ 'PEOPLE.TEAMS' | translate }}</h3>
          <button class="btn btn-link text-decoration-none border-0 p-0" (click)="openTeamAssignationModal(person)">
            <i class="bi bi-pencil-fill me-1"></i> {{ 'PEOPLE.DETAILS.EDIT_TEAMS' | translate }}
          </button>
        </div>
        <div class="card-body pt-3">
          @if (person.teams.length > 0) {
            <ul class="list-unstyled">
              @for (allocation of person.teams; track allocation) {
<li class="list-group-item d-flex justify-content-between align-items-center rounded mb-2 border px-3 py-2">
                <a [routerLink]="['/teams', allocation.team.id]" class="text-dark text-decoration-none">{{ allocation.team.name }}</a>
                <span class="badge bg-light text-black-50 ms-2">{{ allocation.allocation_rate}} %</span>
              </li>
}
            </ul>
          } @else {
            <p class="text-muted">{{ 'PEOPLE.DETAILS.NO_TEAMS_ASSIGNED' | translate }}</p>
          }
        </div>
      </div>
    </div>

    <div class="col-lg-6 mb-4">
      <div class="card shadow-sm border-0">
        <div class="card-header d-flex justify-content-between align-items-center bg-white border-bottom-0 pt-4">
          <h3 class="h5 fw-bold mb-0">{{ 'PEOPLE.SKILLS' | translate }}</h3>
          <button class="btn btn-link text-decoration-none border-0 p-0" (click)="openEditPersonModal(person)">
            <i class="bi bi-pencil-fill me-1"></i> {{ 'PEOPLE.DETAILS.EDIT_SKILLS' | translate }}
          </button>
        </div>
        <div class="card-body pt-3">
          @if (person.skills.length > 0) {
            <ul class="list-unstyled">
              @for (skill of person.skills; track skill) {
<li class="list-group-item rounded mb-2 border px-3 py-2">
                <a [routerLink]="['/skills', skill.id]" class="text-dark text-decoration-none">{{ skill.name }}</a>
              </li>
}
            </ul>
          } @else {
            <p class="text-muted">{{ 'PEOPLE.DETAILS.NO_SKILLS_ASSIGNED' | translate }}</p>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <app-events
      [itemTypeEvents]="'people'"
      [itemId]="person.id"
      #eventsComponent>
    </app-events>
  </div>
</div>